export var AnatomicalSideEnum;
(function (AnatomicalSideEnum) {
    AnatomicalSideEnum["Left"] = "Left";
    AnatomicalSideEnum["Right"] = "Right";
})(AnatomicalSideEnum || (AnatomicalSideEnum = {}));
export var BoneTypeEnum;
(function (BoneTypeEnum) {
    BoneTypeEnum["LongLeg"] = "Long Leg";
    BoneTypeEnum["Femur"] = "Femur";
    BoneTypeEnum["Tibia"] = "Tibia";
    BoneTypeEnum["Ankle"] = "Ankle";
    BoneTypeEnum["Forefoot"] = "Forefoot";
    BoneTypeEnum["Hindfoot"] = "Hindfoot";
})(BoneTypeEnum || (BoneTypeEnum = {}));
export var ReferenceTypeEnum;
(function (ReferenceTypeEnum) {
    ReferenceTypeEnum["Proximal"] = "Proximal";
    ReferenceTypeEnum["Distal"] = "Distal";
})(ReferenceTypeEnum || (ReferenceTypeEnum = {}));
export var BoneViewEnum;
(function (BoneViewEnum) {
    BoneViewEnum["AP"] = "AP";
    BoneViewEnum["LAT"] = "LAT";
})(BoneViewEnum || (BoneViewEnum = {}));
export var PlanTypeEnum;
(function (PlanTypeEnum) {
    PlanTypeEnum["Deformity"] = "Deformity";
    PlanTypeEnum["Fracture"] = "Fracture";
})(PlanTypeEnum || (PlanTypeEnum = {}));
export var InitialFlipType;
(function (InitialFlipType) {
    InitialFlipType[InitialFlipType["horizontal"] = 0] = "horizontal";
    InitialFlipType[InitialFlipType["rotate180"] = 1] = "rotate180";
    InitialFlipType[InitialFlipType["vertical"] = 2] = "vertical";
})(InitialFlipType || (InitialFlipType = {}));
//# sourceMappingURL=CaseModel.js.map